import styled from "styled-components";
import { Colors } from "../../styled";
import { device } from "../../styled/media-queries";

export const CardGridContainer = styled.section`
  display: flex;
  flex-direction: column;
  margin-top: 3rem;
  margin-bottom: 2rem;

  p {
    margin: 0;
  }

  p.category {
    font-size: 18px;
    line-height: 34px;
    letter-spacing: -0.03em;
    text-transform: uppercase;
    color: #000;
  }

  h4.title {
    font-size: 28px;
    line-height: 34px;
    letter-spacing: -0.03em;
    color: #000;
    margin: 8px 0px 20px 0px;
  }

  p.description {
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 150%;
    color: #000;
    max-width: 750px;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 20px;
  margin-top: 32px;

  @media ${device.smallDesktop} {
    grid-template-columns: 1fr 1fr 1fr;
  }

  @media ${device.tablet} {
    grid-template-columns: 1fr 1fr;
  }

  @media ${device.mobile} {
    grid-template-columns: 1fr;
  }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  box-shadow: 0px 1px 15px 2px rgba(0, 0, 0, 0.11);
  min-height: 382px;

  .cover {
    height: 180px;

    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    ${({ imgSrc, renderSrcDirectly }) =>
      renderSrcDirectly
        ? `
        background-image: ${imgSrc};
    `
        : `
        background-image: url(${imgSrc});
    `}
  }

  .card-content {
    display: flex;
    flex-direction: column;
    padding: 20px;
    flex: 1;

    .body {
      flex: 1;

      p.title {
        font-size: 18px;
        line-height: 28px;
        color: ${Colors.Ink};
        margin-bottom: 8px;
      }

      p.description {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
        color: ${Colors.Ink};

        a {
          font-style: normal;
          font-weight: normal;
          font-size: 16px;
          line-height: 24px;
          color: ${Colors.Ink};
        }

        a:hover {
          text-decoration: underline;
        }
      }

      p.subtext {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
        color: #808080;
        margin-top: 8px;
      }
    }

    .footer {
      text-align: right;
      padding-top: 20px;

      a.link {
        font-size: 18px;
        line-height: 21px;
        color: ${Colors.Sky};
        text-decoration: none;

        &:hover {
          cursor: pointer;
        }
      }
    }
  }
`;

export const ShowMore = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 3rem;

  button {
    border-radius: 0;
    border: none;
    padding: 10px 28px;
    background: ${Colors.Midnight};
    color: white;
    font-size: 18px;
    line-height: 21px;
    transition: all 0.5s;

    &:hover {
      cursor: pointer;
    }
  }
`;

export const CardFieldHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;

  p.header {
    margin: 0;
    font-weight: bold;
  }

  a.add {
  }
`;

export const CardField = styled.div`
  display: flex;
  align-items: center;
  margin-top: 1rem;

  .cover {
    flex: 1;

    .image {
      height: 50px;
      width: 50px;
      background-image: url(${({ imgSrc }) => imgSrc});
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      border-radius: 50%;
    }
  }

  .body {
    display: flex;
    flex-direction: column;
    flex: 8;
    padding: 0px 12px;
    overflow: hidden;

    p {
      margin: 0;
    }

    p,
    span {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    p.title {
      font-weight: bold;
    }

    span.description {
    }
  }

  .actions {
    flex: 3;

    display: flex;
    justify-content: flex-end;

    > a {
      color: #1890ff;
      margin-right: 8px;
    }

    > a:last-child {
      margin: 0;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/core/admin/components/CardGrid/misc/styled.js